import React, { useMemo } from 'react';
import { css } from '@emotion/react';

import { useLocale } from '~/src/components/LocaleProvider';
import { resetStyles } from '~/src/styles/reset-styles-mixins';

import { ReactComponent as FacebookIcon } from './facebook-icon.svg';
import { ReactComponent as InstagramIcon } from './instagram-icon.svg';
import { ReactComponent as PinterestIcon } from './pinterest-icon.svg';
import { ReactComponent as XIcon } from './x-icon.svg';
import { ReactComponent as YoutubeIcon } from './youtube-icon.svg';

const styles = {
  container: css(resetStyles.ul, {
    display: 'flex',
    gap: '32px',
    margin: 'auto',
  }),
};
interface Props {
  className?: string;
}

export const SocialLinks: React.FC<Props> = props => {
  const { locale } = useLocale();

  const links = useMemo(() => {
    return {
      facebook:
        locale === 'es'
          ? 'https://facebook.com/yogainternational.esp'
          : 'https://www.facebook.com/yimag',
      x: 'https://twitter.com/YI_Mag',
      youtube:
        locale === 'es'
          ? 'https://www.youtube.com/channel/UCUyEa0j5ycPPQs8Yl3zhUFA'
          : 'https://www.youtube.com/yogainternational',
      pinterest:
        locale === 'es'
          ? 'https://www.pinterest.com/yogainternational/insp%C3%ADrate-aprende-practica/'
          : 'https://www.pinterest.com/yogainternational/',
      instagram:
        locale === 'es'
          ? 'https://www.instagram.com/yoga_internacional/'
          : 'https://www.instagram.com/yoga_international/',
    };
  }, [locale]);

  return (
    <ul css={styles.container} {...props}>
      <li>
        <a aria-label="FaceBook" href={links.facebook} target="_blank">
          <FacebookIcon />
        </a>
      </li>
      <li>
        <a aria-label="X" href={links.x} target="_blank">
          <XIcon />
        </a>
      </li>
      <li>
        <a aria-label="YouTube" href={links.youtube} target="_blank">
          <YoutubeIcon />
        </a>
      </li>
      <li>
        <a aria-label="Pinterest" href={links.pinterest} target="_blank">
          <PinterestIcon />
        </a>
      </li>
      <li>
        <a aria-label="Instagram" href={links.instagram} target="_blank">
          <InstagramIcon />
        </a>
      </li>
    </ul>
  );
};
